import Gallery from "./comp/Gallery";
import styles from "./ItemPage.module.css";
import Info from "./comp/Info";
import Actions from "./comp/Actions";
import { useLocation, useNavigate, useParams } from "react-router";
import useGetItem from "../../../hooks/_REST API/GET/use-get-item";
import Loader from "../../../UI/Loader";
import useScrollStop from "../../../hooks/use-scroll-stop";
import exitIcon from "../../../../assets/x-highlight.png";
import ImageSlider from "../../../UI/ImageSlider";
import { useContext, useEffect } from "react";
import NavigationContext from "../../../store/navigation-context";
import DataContext from "../../../store/data-context";

export default function ItemPage() {
  const location = useLocation();
  const params = useParams().itemSlug;
  const navigate = useNavigate();
  const navCtx = useContext(NavigationContext);

  useScrollStop();

  const [item, getItem] = useGetItem(
    (location.state && location.state.item) || -1,
    params
  );

  const onClose = () => {
    navigate("..");
  };

  return (
    <>
      <div className={styles.background} onClick={onClose} />

      <header></header>
      <div className={styles[`exit-mobile`]} onClick={onClose}>
        <img className={styles[`exit-icon`]} src={exitIcon} alt="Exit." />
      </div>

      <main className={styles.main}>
        <div className={styles[`exit-container`]} onClick={onClose}>
          <img className={styles[`exit-icon`]} src={exitIcon} alt="Exit." />
        </div>
        {item !== undefined && item !== -1 && item !== -2 ? (
          <div className={styles.container}>
            <div className={styles.section}>
              <div className={styles[`mobile-gallery`]}>
                <ImageSlider
                  images={
                    item.images && item.featured_image
                      ? [item.featured_image, ...item.images]
                      : []
                  }
                  featuredImage={item.featured_image}
                />
              </div>
              <div className={styles[`desktop-gallery`]}>
                <Gallery
                  images={item.images || []}
                  featuredImage={item.featured_image}
                />
              </div>
            </div>
            <div className={styles.section}>
              <Info
                title={item.name}
                description={item.description}
                quantity={item.stock_quantity || "0"}
              />
            </div>
          </div>
        ) : (
          <div className={styles.loader}>
            <Loader />
          </div>
        )}
        <div className={styles[`bottom-mobile-padding`]} />
        {!navCtx.isMobile && <Actions item={item} />}
      </main>
      {navCtx.isMobile && (
        <div className={styles[`action-wrapper`]}>
          <Actions item={item} />
        </div>
      )}
    </>
  );
}
